const OtherSpentRow = function($containerEl, otherTTInfo)
{
    TemplateView.call(this, $containerEl);
    this.otherTTInfo = otherTTInfo;
};

OtherSpentRow.prototype = _.create(TemplateView.prototype, {
    baseTemplateModel: function()
    {
        return {
            otherLabel: messageResource.getMessage("view_tt.details_table.other_tt"),
            total: UserTime.formatTimeWithDigitSeparator(this.otherTTInfo["spent"])
        }
    }
});

export default OtherSpentRow


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/OtherSpentRow.js